<template>
    <div class="mb-sm">
        <h4 class="mb-md">Kampanjer</h4>

        <draggable
            v-if="draggableProducts.length > 0"
            v-model="draggableProducts"
            class="mb-md"
            @start="drag=true"
            @end="drag=false"
        >
            <div
                v-for="product in draggableProducts"
                :key="product.id"
                class="flex justify-between rounded bg-neutral-lightest p-lg mb-sm text-sm cursor-move"
            >
                {{ product.internal_name }}
                <div v-if="draggableProducts.length > 1">
                    <font-awesome-icon icon="sort" />
                </div>
            </div>
        </draggable>

        <a class="cursor-pointer" @click="$modal.show('sales-period-products')">
            + Lägg till kampanjer
        </a>

        <adaptive-modal
            name="sales-period-products"
            title="Välj kampanjer"
            :width="900"
            :show-hide-button="false"
            @save="$modal.hide('sales-period-products')"
        >
            <table class="table">
                <thead>
                    <tr>
                        <td class="font-semibold">Kampanjnamn</td>
                        <td class="font-semibold text-right">Startavgift</td>
                        <td class="font-semibold text-right">Bindningstid</td>
                        <td class="font-semibold text-right">Månadsavgift</td>
                    </tr>
                </thead>
                <tbody class="text-sm text-neutral-dark">
                    <sales-period-product
                        v-for="product in products"
                        :key="product.id"
                        :product="product"
                        :selected-products="selectedProducts"
                        :update-product="updateProduct"
                    />
                </tbody>
            </table>
        </adaptive-modal>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import SalesPeriodProduct from './SalesPeriodProduct';

    export default {
        components: {
            draggable,
            SalesPeriodProduct,
        },

        props: {
            products: {
                required: true,
                type: Array,
            },
            selectedProducts: {
                required: true,
                type: Array,
            },
            updateProduct: {
                required: true,
                type: Function,
            },
            updateProducts: {
                required: true,
                type: Function,
            },
        },

        data() {
            return {
                draggableProducts: [],
            };
        },

        watch: {
            draggableProducts() {
                this.updateProducts(this.draggableProducts);
            },
        },

        created() {
            this.draggableProducts = this.selectedProducts;
        },
    };
</script>
